import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { useTab } from "@mui/base";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import moment from "moment";
import {
  createCustomerAction,
  getAllCustomersAction,
} from "../../../../services/Store/Actions/customerAction";
import AddDriverV2 from "../../../TripsMainV2/Components/AddDriverV2";
import AddVehicleV2 from "../../../TripsMainV2/Components/AddVehicleV2";
import { toastStatus } from "../../../../services/Store/Actions/appActions";
import { useNavigate } from "react-router-dom";
import {
  addTripAddress,
  getAddressFromPincodeAction,
  getPinCodeData,
  getSavedAddress,
  findTripAddressV2,
  addDriverV2,
} from "../../../../services/Store/Actions/TripsAction";
import AddAddress from "../../../LoadReceipt/Components/AddAddress";
import { Checkbox } from "@material-ui/core";
import PinInput from "react-pin-input";
import {
  registorNewCustomer,
  registorNewCustomerVerifyOtpSuccess,
} from "../../../../services/Store/Actions/walletAction";
import { registorNewCustomerVerifyOtp } from "../../../../services/Store/Actions/walletAction";
import MinKycModal from "../minKyc";
import YBLTermsConditionsModal from "../../../Modals/YBLTermsConditionsModal";

function AddDriverModal(props) {
  const { toggle, modal, setModal, navigatedFrom,userIdFix,setUserIdFix,setSend,send } = props;
  console.log("navigatedFrom", navigatedFrom);
  const [openToast, setOpenToast] = useState(false);
  const [temp, setTemp] = useState(navigatedFrom);
  const [display1, setDisplay1] = useState(false);
  const [search1, setSearch1] = useState("");
  const [color1, setColor1] = useState(-1);
  const [address, setAddress] = useState(false);
  const addAddress = () => setAddress(!address);
  console.log("navigatedFrom2222", temp);

  const [addressList, setAddressList] = useState(false);
  const [openMinKyc, setOpenMinKyc] = useState(false);
  const [userData, setUserData] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { savedAddresses } = useSelector((state) => state?.trip);
  const toastObject = useSelector((state) => state?.app?.toastObject);
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Please enter your First name"),
    phone: Yup.string()
      .required("Phone number must contain 10 digits")
      .matches(
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        "Phone number must contain 10 digits"
      ),
  });
  const handleClose = () => {
    setModal(!modal);
  };
  useEffect(() => {
    if (display1 == true) {
      // dispatch(findTripAddressV2({},(res)=>{
      //   console.log("findTripAddressV2",res);
      // }))
      dispatch(
        getSavedAddress({ address: search1 }, (res) => {
          console.log("getSavedAddress", res);
        })
      );
    }
  }, [display1, search1]);
  const handleCloseopenMinKyc = () => {
    setOpenMinKyc(false);
  };

  const toggleModalopenMinKyc = () => {
    setOpenMinKyc(!openMinKyc);
  };

  const showModalopenMinKyc = () => {
    setOpenMinKyc(true);
  };
  const verifyOtp = (otp) => {
    dispatch(
      registorNewCustomerVerifyOtp(
        {
          phone: userIdFix?.phone,
          otp: otp,
        },
        (resp) => {
          console.log("uuuufuufufu", resp);
          if(resp?.data?.type == 'success' && resp?.status == 200){
            showModalopenMinKyc();
            setUserData({...resp?.data?.data?.user,fullName : (userIdFix?.firstName+" "+userIdFix?.lastName)})
          }
          handleClose();
        }
      )
    );
  };
  const [openT, setOpenT] = useState(false);
  const toggleTermModal = () => {
    setOpenT(!openT);
  };
  const handleTermClose = () => {
    setOpenT(false);
  };
  const handleTermShow = () => {
    setOpenT(true);
  };

  return (
    <div>
      <YBLTermsConditionsModal
        handleClose={handleTermClose}
        open={openT}
        toggleModal={toggleTermModal}
      />
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width model-Radius"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody"
          //   style={{ marginTop: "25px" }}
        >
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>
          <div
            style={{ marginTop: " 30px" }}
            //   className="PGCollectionBox"
          >
            <div
              className="PGCollectiontText col-9"
              style={{ marginLeft: "50px" }}
            >
              Add Driver
            </div>

            <Formik
              // isValid='true'
              enableReinitialize
              validationSchema={validationSchema}
              initialValues={{
                phone: userIdFix ? userIdFix?.phone  : "",
                firstName: userIdFix  ? userIdFix?.firstName : "",
                lastname: userIdFix ? userIdFix?.lastName : "",
                otp: "",
                agree: false,
                driverCode : "",
              }}
              onSubmit={(values, actions) => {
                if(userIdFix?.userId){
                    dispatch(
                        registorNewCustomer(
                            userIdFix?.userId,
                          (res) => {
                            console.log("eeeergrere", res);
                            if (res?.type == "success") {
                              //TODO
                              setSend(true);
                              setUserIdFix({...userIdFix,phone : values?.phone});
                            //   setUserId(userIdFix?.userId);
                            }
                          }
                        )
                      );
                }
                // setOpenToast(true);
                else{
                    console.log("jkkjsjs",values?.driverCode)
                    let reqValue = {
                        phone: values?.phone,
                        fullName: `${
                          values?.firstName +
                          (values?.lastname ? " " + values?.lastname : "")
                        }`,
                      }
                    if(values?.driverCode){
                        reqValue["driverCode"] = values?.driverCode
                    }
                    dispatch(
                        addDriverV2(reqValue,
                          (resp) => {
                            console.log("njnevirgier", resp);
                            if (
                              resp?.status == 200 &&
                              resp?.data?.type == "success"
                            ) {
                              console.log("njnevirgier", resp?.data?.data?.userId);
                              dispatch(
                                registorNewCustomer(
                                  resp?.data?.data?.userId,
                                  (res) => {
                                    console.log("eeeergrere", res);
                                    if (res?.type == "success") {
                                      //TODO
                                      setSend(true);
                                      setUserIdFix({
                                        userId : resp?.data?.data?.userId,
                                        firstName : values?.firstName,
                                        lastName : values?.lastname,
                                        phone : values?.phone
                                      })
                                    //   setUserId(resp?.data?.data?.userId);
                                    }
                                  }
                                )
                              );
                            }
                          }
                        )
                      );
                }

                // handleClose();
              }}
            >
              {({
                handleBlur,
                handleChange,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                  style={{ marginTop: "40px", padding: "0 0px 0 55px" }}
                >
                  <FormGroup>
                    <div className="row">
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            First Name
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="firstName"
                            className={`inputBoxAddCust ${
                              touched.firstName && errors.firstName
                                ? "is-invalid"
                                : ""
                            }`}
                            name="firstName"
                            value={values.firstName}
                            onChange={handleChange("firstName")}
                            onBlur={handleBlur("firstName")}
                            touched={touched.firstName}
                            errors={errors.firstName}
                            placeholder="First Name"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.firstName && touched.firstName ? (
                              <div>*{errors.firstName}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Last Name
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="lastname"
                            className={`inputBoxAddCust ${
                              touched.lastname && errors.lastname
                                ? "is-invalid"
                                : ""
                            }`}
                            name="lastname"
                            value={values.lastname}
                            onChange={handleChange("lastname")}
                            onBlur={handleBlur("lastname")}
                            touched={touched.lastname}
                            errors={errors.lastname}
                            placeholder="Last Name"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.lastname && touched.lastname ? (
                              <div>*{errors.lastname}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Phone Number
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="phone"
                            className={`inputBoxAddCust ${
                              touched.phone && errors.phone ? "is-invalid" : ""
                            }`}
                            name="phone"
                            value={values.phone}
                            onChange={handleChange("phone")}
                            onBlur={handleBlur("phone")}
                            touched={touched.phone}
                            errors={errors.phone}
                            placeholder="Phone Number"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.phone && touched.phone ? (
                              <div>*{errors.phone}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-3 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Driver Code (Optional)
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="driverCode"
                            className={`inputBoxAddCust ${
                              touched.driverCode && errors.driverCode ? "is-invalid" : ""
                            }`}
                            name="driverCode"
                            value={values.driverCode}
                            onChange={handleChange("driverCode")}
                            onBlur={handleBlur("driverCode")}
                            touched={touched.driverCode}
                            errors={errors.driverCode}
                            placeholder="Driver Code"
                            readOnly={userIdFix?.userId ? true :false}
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.driverCode && touched.driverCode ? (
                              <div>*{errors.driverCode}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup
                    // style={{
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "space-between",
                    //   marginTop: "30px",
                    // }}
                    style={{
                      padding: "0px 0 0 0",
                    }}
                  >
                    <div style={{}} className="row">
                      <div
                        className="offset-3 col-1"
                        style={{ padding: "0 0 0 40px" }}
                      >
                        <Checkbox
                          value={values?.agree}
                          sx={{
                            color: "#6c6c6c",
                            "&.Mui-checked": {
                              color: "#2E7C7B",
                            },
                          }}
                          onChange={(e) => {
                            console.log("kjdjjdjd", e?.target?.checked);
                            setFieldValue("agree", e?.target?.checked, true);
                          }}
                        />
                      </div>
                      <div
                        className="col-6 FontNS16"
                        style={{
                          paddingTop: "9px",
                          textDecoration: "underline",
                        }}
                        onClick={()=>{handleTermShow()}}
                      >
                        I Accept, terms & Conditions
                      </div>
                      {console.log("jdjiekek", values)}
                      <div
                        className="col-12"
                        style={{
                          textAlign: "center",
                          padding: "0 99px 0 0px",
                        }}
                      >
                        <Button
                          type="submit"
                          style={{ width: "160px", borderRadius: "5px" }}
                          className="generateOtp textAddCust Medium btn"
                          //   onClick={sendOtp}
                          disabled={values?.agree && !send ? false : true}
                        >
                          {send ? "OTP Sent" : "Send OTP"}
                        </Button>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup
                    style={{
                      padding: "25px 0 0 0",
                      textAlign: "center",
                    }}
                  >
                    <div className="row">
                      <div className="col-12">
                        <PinInput
                          name="otp"
                          length={6}
                          initialValue=""
                          secret
                          onChange={(value, index) =>
                            setFieldValue("otp", value, true)
                          }
                          type="numeric"
                          inputMode="number"
                          style={{
                            padding: "10px 74px 46px 10px",
                          }}
                          inputStyle={{
                            border: "1px solid #A7A7A7",
                            borderRadius: "8px",
                            marginRight: "20px",
                          }}
                          onComplete={(value, index) => {}}
                          autoSelect={true}
                          regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                        />
                      </div>
                      <div
                        className="col-12"
                        style={{
                          textAlign: "center",
                          padding: "0 99px 0 0px",
                        }}
                      >
                        <Button
                          style={{
                            width: "160px",
                            borderRadius: "5px",
                          }}
                          className="generateOtp textAddCust Medium btn btn-secondary"
                          onClick={() => {
                            verifyOtp(values?.otp)
                          }}
                        >
                          Verify OTP
                        </Button>
                      </div>
                    </div>
                  </FormGroup>
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
      <MinKycModal
        toggle={toggleModalopenMinKyc}
        modal={openMinKyc}
        setModal={setOpenMinKyc}
        userId={userIdFix?.userId}
        userData={userData}
      />
    </div>
  );
}

export default AddDriverModal;
